import { getAuthStorageKeys } from "./auth-storage";
import { createReferenceCache } from "./referenceCache";

export const managementReferenceCache = createReferenceCache({
  scope: () => {
    const { access } = getAuthStorageKeys();
    return typeof localStorage === "undefined" ? access : `${access}:${localStorage.getItem(access) || ""}:${localStorage.getItem(`${access}:session`) || ""}`;
  },
});
